import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule, TranslateModule } from '@interticket/core';
import { HamburgerComponent } from './components/hamburger/hamburger.component';
import { LanguagePickerComponent } from './components/language-picker/language-picker.component';
import { PartnerMonogramPipe } from './enums/partner-monogram.pipe';

const commonComponents = [
  LanguagePickerComponent,
  HamburgerComponent,
];

const pipes = [
  PartnerMonogramPipe,
];

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
  ],
  declarations: [
    ...commonComponents,
    ...pipes,
  ],
  exports: [
    ...commonComponents,
    ...pipes,
  ],
})
export class ITCommonModule { }
